import { createFileRoute } from "@tanstack/react-router";
import DocumentBlogArticle from "@/components/site/DocumentBlogArticle";
import { blogDrafts } from "@/lib/blog-drafts";
import { documentBlogHead } from "@/lib/document-blog-head";

export const Route = createFileRoute("/what-is-substance-abuse-evaluation-nj")({
  head: () => documentBlogHead(blogDrafts.evaluation),
  component: EvaluationBlog,
});

function EvaluationBlog() { return <DocumentBlogArticle draft={blogDrafts.evaluation} />; }